export default {
    login1: 'Already have an account?',
    login2: 'Go to login',
    login3: 'Reset password?',
    login4: 'Start using 51shopy',
    login5: 'Forgot your password?',
    login6: 'Register now',
    login7: 'Email',
    login8: 'Verification code',
    login9: 'Enter verification code',
    login10: 'Password',
    login11: 'Confirm password',
    login12: 'Please enter your password again',
    login13: 'Register',
    login14: 'Next',
    login15: 'Submit',
    login16: 'Send verification code',
    login17: 'Please enter the correct email address and verification code! ',
    login18: 'The two passwords you entered do not match!',
    login19: 'Verification code has been sent',
    login20: 'Email cannot be empty',
    login21: 'Email format is incorrect',
    login22: 'Verification code cannot be empty',
    login23: 'Verification code length is 4 characters',
    login24: 'Password cannot be empty',
    login25: 'Password length cannot be less than 6 characters',
    login26: 'Password modified successfully! ',
    login27: 'Registration successful! ',
    login28: 'Login successful',
    login29: 'Account name cannot be empty',
    login30: 'Log in to your account below to get started',
    login31: 'Account',
    login32: 'Click to log in',
    login33: "Buy quality goods and enjoy bonuses",
    login34: "Register to enjoy a beautiful gift",
    login35: "Login",
    login36: "Register",

    home1: 'Popular',
    home2: 'Are you sure you want to log out? ',
    home3: 'Prompt',
    home4: 'Confirm',
    home5: 'Cancel',
    home6: 'Fans',
    home7: 'Follow',
    home8: 'Personal Center',
    home9: 'My Purchases',
    home10: 'My Sales',
    home11: 'My Wallet',
    home12: 'Exit',
    home13: 'Total',
    home14: 'Items',
    home15: 'Settlement',
    home16: 'Affordable Prices',
    home17: 'Fast Logistics',
    home18: 'Quality Assurance',
    home19: 'About Us',
    home20: 'Help Center',
    home21: 'After-sales Service',
    home22: 'Delivery and Acceptance',
    home23: 'Business Cooperation',
    home24: 'Search Recommendations',
    home25: 'Friendly links',
    home26: 'Follow',
    home27: 'followed',
    home28: 'Buy now',
    home29: 'Add to cart',
    home30: 'Added to favorites successfully! ',
    home31: 'Canceled from favorites successfully! ',
    home32: 'Are you sure you want to cancel the follow?',
    home33: 'Canceled successfully! ',
    home34: 'Followed successfully! ',
    home35: 'Content cannot be empty',
    home36: 'Commented successfully!',
    home37: 'Product evaluation',
    home38: 'Evaluate now',
    home39: 'Evaluation',
    home40: 'History',
    home41: 'Canceled from favorites successfully! ',
    home42: `This guy is very mysterious and didn't write a personal profile. `,
    home43: 'Homepage',
    number1: 'My account',
    number2: 'Personal center',
    number3: 'Wallet',
    number4: 'My collection',
    number5: 'My attention',
    number6: 'My fans',
    number7: 'History browsing',
    number8: 'Transaction management',
    number9: 'My posts',
    number10: 'My purchases',
    number11: 'My sales',
    number12: 'Shopping cart',
    number13: 'Personal homepage',
    number14: 'Customer service',
    number15: 'Settings',
    number16: 'Add address',
    number17: 'Modify address',
    number18: 'Only image files can be uploaded!',
    number19: 'File size cannot exceed 10MB!',
    number20: 'Image upload successful',
    number21: 'Balance',
    number22: 'Add to Favorites',
    number23: 'Personal Information',
    number24: 'Edit',
    number25: 'Submit',
    number26: 'Nickname',
    number27: 'Personal Profile',
    number28: 'Delivery Address',
    number29: 'Add',
    number30: 'Default',
    number31: 'Unpaid',
    number32: 'Waiting for Shipment',
    number33: 'Completed',
    number34: 'Cancelled',
    number35: 'Waiting for Review',
    number36: 'Approved',
    number37: 'Rejected',
    number38: 'Order Completed',
    number39: 'Order Payment Successfully!',
    number40: 'Order Cancelled Successfully! ',
    number41: 'Withdrawal Successfully! ',
    number42: 'Recharge',
    number43: 'Withdraw',
    number44: 'Consumption history',
    number45: 'Order number',
    number46: 'Payment name',
    number47: 'All',
    number48: 'Query',
    number49: 'Order number',
    number50: 'Payment name',
    number51: '51 coin',
    number52: 'Order status',
    number53: 'Order creation time',
    number54: 'Order update time',
    number55: 'Operation',
    number56: 'Paid',
    number57: 'Cancel order',
    number58: 'Details',
    number59: 'Number',
    number60: 'Shipped',
    number61: 'Pending',
    number62: 'Withdrawal record',
    number63: 'User id',
    number64: 'Withdrawal amount',
    number65: 'Status',
    number66: 'Creation time',
    number67: 'Wallet withdrawal',
    number68: 'Withdrawal',
    number69: 'Wallet order details',
    number70: 'All orders',
    number71: 'Waiting for payment',
    number72: 'Waiting for shipment',
    number73: 'Completed',
    number74: 'Cancelled',
    number75: 'Paid',
    number76: 'All shipped',
    number77: 'Logistics order number',
    number78: 'Successful shipment!',
    number79: 'I sold it',
    number80: 'No order data yet',
    number81: 'Order number',
    number82: 'Order time',
    number83: 'Order person',
    number84: 'Change time',
    number85: 'Order details',
    number86: 'Total',
    number87: 'Shipment',
    number88: 'Details',
    number89: 'Fill in the logistics order number',
    number90: 'Logistics order number',
    number91: 'Please enter the logistics order number',
    number92: 'Cancelled successfully!',
    number93: 'Successful!',
    number94: 'Order delayed delivery successfully!',
    number95: 'I bought it',
    number96: 'Pay now',
    number97: 'Confirm receipt',
    number98: 'Delayed receipt',
    number99: 'Cancel order',
    number100: 'Seller user',
    number101: 'My favorite',
    number102: 'My fans',
    number103: 'My followers',
    number104: 'Payment name',
    number105: '51 Coins',
    number106: 'Order Status',
    number107: 'Payment Time',
    number108: 'I have paid',
    number109: 'Order payment is successful! ',
    number110: 'All products',
    number111: 'Are you sure to delete the product?',
    number112: 'Delete successfully! ',
    number113: 'Cancel successfully! ',
    number114: 'Are you sure to put the product on the shelf?',
    number115: 'Are you sure to remove the product?',
    number116: 'Success! ',
    number117: 'Put on the shelf',
    number118: 'Remove from the shelf',
    number119: 'Delete',
    number120: 'View details',
    cart1: 'Product information',
    cart2: 'Unit price',
    cart3: 'Quantity',
    cart4: 'Subtotal',
    cart5: 'Operation',
    cart6: 'Unit price',
    cart7: 'Are you sure you want to delete?',
    cart8: 'Confirm',
    cart9: 'Cancel',
    cart10: 'Delete',
    cart11: 'The shopping cart list is empty',
    cart12: 'Items, total',
    cart13: 'Total',
    cart14: 'Settlement',
    cart15: 'Add address',
    cart16: 'One of telegram and watchApp must be filled in',
    cart17: 'User information configuration is successful!',
    cart18: 'Please select or fill in the delivery address! ',
    cart19: 'Order created successfully! ',
    cart20: 'Delivery address',
    cart21: 'You need to add the delivery address before submitting the order. ',
    cart22: 'Consignee',
    cart23: 'Contact information',
    cart24: 'Delivery address',
    cart25: 'Switch address',
    cart26: 'Add address',
    cart27: 'Product information',
    cart28: 'Unit price',
    cart29: 'Quantity',
    cart30: 'Actual payment',
    cart31: 'Total price',
    cart32: 'Amount details',
    cart33: 'Total amount payable',
    cart34: 'Submit order',
    cart35: 'Switch delivery address',
    cart36: 'Cancel',
    cart37: 'Confirm',
    cart38: 'User information',
    cart39: 'Submit',
    cart40: 'Surname cannot be empty',
    cart41: 'First name cannot be empty',
    cart42: 'Mobile number cannot be empty',
    cart43: 'Country cannot be empty',
    cart44: 'Province/Municipality/District cannot be empty',
    cart45: 'City cannot be empty',
    cart46: 'Detailed address cannot be empty',
    cart47: 'Postal code cannot be empty',
    cart48: 'Address modified successfully! ',
    cart49: 'Address added successfully! ',
    cart50: 'Surname',
    cart51: 'First Name',
    cart52: 'Country',
    cart53: 'Province/Municipality/District',
    cart54: 'City',
    cart55: 'Detailed Address',
    cart56: 'Postal Code',
    cart57: 'Contact Number',
    cart58: 'Is it default',
    cart59: 'Homepage',
    cart60: 'Customer Service',
    cart61: 'Publish',
    cart62: 'My',
    cart63: 'Cart',
    cart64: 'Shipping Time',
    cart65: 'Payment Time',
    cart66: 'Receipt Information',
    cart67: 'Actual Payment',
    cart68: 'Delivered to',
    cart69: 'Products',
    cart70: 'You can apply for invoice',
    cart71: 'Order Information',
    cart72: 'Merchant',
    cart73: 'Submission successful! ',
    cart74: 'Copy successfully',
    cart75: 'Copy failed',
    cart76: 'Proportion',
    cart77: 'Credit limit',
    cart78: 'Transfer',
    cart79: 'Recharge amount',
    cart80: 'Recharge',
    cart81: 'Category',
    setup1: 'Personal information',
    setup2: 'My delivery address',
    setup3: 'My profile',
    setup4: 'Account and security',
    setup5: 'Privacy',
    setup6: 'General',
    setup7: 'Help and feedback',
    setup8: 'About us',
    setup9: 'Log out',
    setup10: 'Site message',
    setup11: 'No data yet',
    setup12: 'Add to cart successfully!',
    setup13: 'Add to cart failed!',

    setup14: 'Product Edit',
    setup15: 'Product Release',
    setup16: 'Product Cover Image',
    setup17: 'Product Category',
    setup18: 'Product Name',
    setup19: 'Product Price (CNY)',
    setup20: 'Product Description',
    setup21: 'Product Image (Max 10 images)',
    setup22: 'Reset',
    setup23: 'Product Created Successfully! ',



    setup24: 'Insufficient product inventory! ',
    setup25: 'Payment method',
    setup26: '51 coin',
    setup27: 'Transfer',
    setup28: 'Product link or name/item link',
    setup29: 'The user is not a seller and cannot publish products! ',
    setup30: 'Non-human operation detected! ',
    setup31: 'Product inventory',
    setup32: 'Views',
    setup33: 'Order submitted successfully! ',
    setup34: 'View order',
    setup35: 'Product inventory',
    setup36: 'Product category cannot be empty',
    setup37: 'Product name cannot be empty',
    setup38: 'Product description cannot be empty',
    setup39: 'Product inventory cannot be empty',
    setup40: 'Product price cannot be empty',
    setup41: 'Cover image cannot be empty',
    setup42: 'Product image cannot be empty',
    setup43: 'Transfer has been made and is awaiting confirmation',
    setup44: 'Please select the transfer method! ',
    setup45: 'Completion time',
    setup46: '51 coin payment',
    setup47: 'Transfer payment',
    setup48: 'Transfer method',
    setup49: "Product details",
    setup50: "Buyer",
    setup51: "Product shipping cost",
    setup52: "Shipping cost",
    setup53: "Sales quantity",
    setup54: "Minimum purchase quantity",
    setup55: "Add address",
    setup56: "Received",
    setup57: "Payee contact information",
    setup58: "Merchant contact information",
    setup59: "Buyer contact information",
    setup60: "Copy",
    setup61: "Popular",
    setup62: "Fill in at least one field",
    setup63: "Contact us",
    setup64: "Shipping cost estimate",
    setup65: "Subscribe to us",
    setup66: "Overseas influencer cooperation",
    setup67: "Payment and after-sales issues",
    setup68: "User dividends",

    setup69: "Currency type",
    setup70: "Exchange rate",
    setup71: "Handling fee",
    setup72: "Actual amount received",
    setup73: "Minimum withdrawal amount",
    setup74: "Currency",
    setup75: "Handling fee",
    setup76: "Actual amount received",

    setup78: "Invitation code",
    setup79: "Please enter invitation code",
    setup80: "Mobile area code cannot be empty",
    setup81: "Area code",
    setup82: "Cancel time",
    setup83: "Withdrawal details",
    setup84: "Dividend details",
    setup85: "Is it expired",
    setup86: "Is it used",
    setup87: "Not expired",
    setup88: "Expired",
    setup89: "Not used",
    setup90: "Used",
    setup91: "Partially used",
    setup92: "Rebate",
    setup93: "Used rebate",
    setup94: "Remaining rebate",
    setup95: "Whether to use",
    setup96: "Whether expired",
    setup97: "Expiration time",
    setup98: "Rebate time",
    setup99: "Alliance sharing",
    setup100: "Cancel payment",
    setup101: "Close interface",
    setup102: "USDT payment",
    setup103: "Final Amount",
    setup104: "Order transaction amount",
    setup105: "Network",
    setup106: "You pay the network fee",
    setup107: "Payment successful",
    setup108: "Payee wallet address",
    setup109: "Please carefully check that the actual payment amount is consistent with the amount you transferred. If there is any mistake, the consequences will be borne by yourself",
    setup110: "Expiration time",
    setup111: "Waiting for payment",
    setup112: "Payment successful",
    setup113: "Order expired",
    setup114: "Check blockchain transactions",
    setup115: "",
    setup116: "",
    setup117: "",
    setup118: "",
    setup119: "",

    setup130: "About Us",
    setup131: "Delivery Related",
    setup132: "Other",
    setup133: "Shipping Policy",
    setup134: "Package Delivery/Pickup Time",
    setup135: "Terms of Service",
    setup136: "Payment Method",
    setup137: "Return Policy",
    setup138: "Privacy Policy",
    setup139: "Space Network Technology Co., Ltd.",
    setup140: "Working Hours:",
    setup141: "Contact Person:",
    setup142: "Company Email:",
    setup143: "Postal Code:",
    setup144: "Address:",

    setup0140: "Monday to Friday (9:00-18:00)",
    setup0141: " Mr. Liang",
    setup0143: "999077",
    setup0144: "3 Public Industrial Building, 56 Hoi Yuen Road, Kwun Tong, Hong Kong Floor 341, Room",

    setup145: "International Parcel Transportation Agreement",
    setup146: "In view of the particularity of international transportation, you need to comply with the international parcel transportation rules. Please be sure to read carefully and accept the following terms and conditions. ",
    setup147: "Package Compensation Standard:",
    setup148: "If your product is lost, missing, damaged, delayed or detained by customs during transportation due to reasons beyond 51shopy's control, 51shopy will not be liable for compensation. We also do not bear any compensation liability for indirect and unrealized profit losses. For actual details, please refer to 'Package Insurance and Compensation'. ",
    setup149: "In the following cases, 51shopy is not responsible for compensation (for uninsured parcels):",
    setup150: "1. No compensation will be given for mail loss due to force majeure such as natural disasters or customs reasons;",
    setup151: "2. If the mailed items violate prohibitions or restrictions, the competent authorities will confiscate them or deal with them in accordance with relevant laws and regulations, and no compensation will be given;",
    setup152: "3. When sending a parcel, if the package is intact, there is no sign of disassembly, the weight has not been reduced, but the internal parts are missing or damaged, no compensation will be given;",
    setup153: "4. If the mail track shows that it was not delivered normally, and the logistics company confirms that the package has been confiscated by the customs, the logistics company's inquiry shall prevail and no compensation will be given;",
    setup154: "5. No compensation will be given if the mail is lost or the content is missing due to the customer's responsibility or the mail itself;",
    setup155: "6. If the customer does not inquire and does not file a claim from the date of delivery of the mail to the expiration of the inquiry period, no compensation will be given;",
    setup156: "7. If international mail is detained, confiscated or destroyed by the destination country in accordance with its domestic laws, no compensation will be given.",
    setup157: "Prohibited items",
    setup158: "Comply with the regulations of our country on prohibited and restricted items:",
    setup159: "1. Comply with the announcement of the State Post Bureau, the Ministry of Public Security, and the Ministry of State Security on the promulgation of the 'Regulations on the Management of Prohibited Articles'. ",
    setup160: "2. Comply with the provisions of General Administration of Customs Order No. 43 (List of Articles Prohibited or Restricted from Entering or Leaving the Country of the People's Republic of China). ",
    setup161: "Articles that cannot be sent by mail",
    setup162: "1. Articles prohibited from circulation or transportation by national laws. ",
    setup163: "2. Explosive, flammable, corrosive, radioactive or toxic dangerous goods. ",
    setup164: "3. Publications, books, materials or articles containing reactionary or obscene content. ",
    setup165: "4. Various currencies. ",
    setup166: "5. Articles that violate public health. ",
    setup167: "6. Perishable articles. ",
    setup168: "7. Live animals (except bees, silkworms and leeches, as long as the packaging ensures the safety of workers). ",
    setup169: "8. Articles that are not adequately packaged and may cause danger to workers or contaminate or damage other packaged articles. ",
    setup170: "9. Other items not suitable for mailing. ",
    setup171: "Items prohibited from mailing according to postal practice",
    setup172: "1. Items whose quality or packaging may cause harm to postal workers or contaminate/damage other packages or postal equipment. ",
    setup173: "2. Items with metal seals or other sharp edges that may hinder postal processing. ",
    setup174: "3. Various types of firearms, ammunition, explosive, flammable, corrosive, radioactive items or containers, strong poisons, narcotics, biochemical products and infectious items. ",
    setup175: "4. Various publications, propaganda materials, and printed materials that may endanger social security and stability or contain obscene content. ",
    setup176: "5. Various items that may endanger public health. ",
    setup177: "6. Documents or items that are not accepted or allowed to circulate in the receiving country. ",
    setup178: "Available payment methods",
    setup179: "The website supports multiple payment methods, including credit/debit cards, WeChat, Alipay, etc. If you need to make frequent payments or escrow deductions, you can also use the balance to pay. ",
    setup180: " - If a refund occurs for a credit/debit card purchase order, it will be refunded to the original account; the refund for the balance recharge will also be refunded to the original account",
    setup181: " - If a refund occurs for WeChat, Alipay and other order payments, it will be refunded to the original account;",
    setup182: " - If a refund occurs for the balance payment, it will be refunded to the account balance;",
    setup183: "51shopy User Privacy Policy",
    setup184: "The security of your personal information is very important to us, and we value your trust. Under no circumstances will we sell or disclose your personal information to third parties. We will protect the security and privacy of any personal information you provide to us, and will only use the information we describe here. If you have any questions, suggestions or comments about this Privacy Policy, you can contact us at any time by visiting the 51shopy online customer service system or the 51shopy official service account. ",
    setup185: "This policy does not apply to services provided to you by other third parties, nor does it apply to services for which we independently set privacy policies. ",
    setup186: "Please read and thoroughly understand this policy before using 51shopy services. Your agreement to this Privacy Policy represents that you have understood the functions provided by this application and the necessary personal information required to run the function. ",
    setup187: "The ownership and operation rights of the relevant registered user services belong to  ",
    setup188: "1. What personal information do we collect? ",
    setup189: "You can choose to use or visit our website without disclosing any personal and transaction information about you, but you need to register an account to experience our full service. If you provide us with your information, you agree to transfer and store the information on our servers. ",
    setup190: "51shopy collects personal information you provide when using this website, including your name, contact information, email address, 51shopy account name and password, and other information required for you to create an account. In addition to the personal information we may collect and process when registering, we also collect, store and process the following information about our users on 51shopy:",
    setup191: "1) Purchase information",
    setup192: "2) Service account information",
    setup193: "3) Payment information (payment time, payment amount, payment channel, etc.)",
    setup194: "4) Search browsing history information (search content, link click behavior, browsing history, click view history, etc.)",
    setup195: "5) Cookies and other computer information",
    setup196: "We work with Microsoft Clarity and Microsoft Advertising to capture how you use and interact with our website through behavioral indicators, heat maps and session replays to improve and market our products/services. Use first-party and third-party cookies and other tracking technologies to capture website usage data to determine the popularity of products/services and online activities. In addition, we use this information for website optimization, fraud/security purposes, and advertising. For more information on how Microsoft collects and uses your data, please visit ",
    setup197: "Microsoft Privacy Statement",
    setup198: "2. How do we use your personal information? ",
    setup199: "We will not sell or disclose any user's personal information, and strive to protect your information and privacy. We will use your information to provide you with better services, including: ",
    setup200: "1) Contact you via email and provide you with our range of services, including consulting services, order information services, package information services, product after-sales services, etc. ",
    setup201: "2) Communicate platform activities to you through email, internal letters, etc., including providing you with coupons, shipping discounts and special promotions, and providing opportunities to use third-party services. ",
    setup202: "3) When you search and browse the links of our partner merchants on 51shopy, your 51shopy user ID, related operation behaviors and information (search content, link click behavior, browsing history, click view history, etc.) will be provided to the source of the operation behavior link simultaneously, so that we and our partner merchants can jointly provide you with high-quality and efficient services. You can click to view 51shopy partner merchants (www.taobao.com, www.1688.com). ",
    setup203: "According to laws, regulations and national standards, in the following circumstances, the use, transfer and disclosure of your personal information by the partners does not require your authorization and consent:",
    setup204: "1) According to the mandatory requirements of laws, regulations, administrative and judicial organs and other legal obligations;",
    setup205: "2) To safeguard the public interest, property safety, protect you or other 51shopy users, 51shopy, 51shopy's affiliates or partners from damage within the scope permitted by laws and regulations;",
    setup206: "3) To achieve the core functions of our products and/or services, or to provide the services you need;",
    setup207: "4) To process your personal information disclosed by you or other personal information that has been legally disclosed (such as personal information legally disclosed through legal news reports, government information disclosure or other channels) within a reasonable scope;",
    setup208: "5) To handle disputes or controversies between you and others according to your needs;",
    setup209: "6) To comply with the provisions of relevant agreements signed with you (including online electronic agreements and corresponding platform rules) or other legal documents;",
    setup210: "7) Use based on social public interests and public health emergencies and in compliance with laws and regulations.",
    setup211: "For the above purposes, you also have the right to cancel this notice at any time. You can log in to the 51shopy website and set it yourself in the custom function.",
    setup212: "Please note that we will not share your personal data with any advertiser unless you agree. We will not request or publish personal information from children or other incapable persons without the consent, knowledge and presence of their guardians.",
    setup213: "You hereby understand that sharing and transferring de-identified personal information and guaranteeing that the data recipient cannot restore and re-identify the subject of personal information do not constitute sharing, transfer and public disclosure of personal information to the outside world. The storage and processing of such data does not require notification to you and your consent.",
    setup214: "We may entrust authorized partners to process your personal information to authorize partners to provide you with certain services or perform certain functions on our behalf. We will only entrust the processing of your information for the legitimate, legitimate, necessary, specific and clear purposes stated in this policy, and authorized partners can only access information necessary to perform their duties. 51shopy will not provide your email address, 51shopy website account name and password, contact information and other private information to our partners. ",
    setup215: "3. How long will we keep your information? ",
    setup216: "Once you successfully register a 51shopy account, we will permanently save your personal information. If you want to cancel your account or delete your personal information, please contact online customer service.",
    setup217: "According to GDPR, data controllers and processors are obliged to return or delete all personal data after the end of the service or the expiration of the contract or agreement, unless the data needs to be retained as required by law.",
    setup218: "4. How do we protect your personal information?",
    setup219: "We will take all reasonable and feasible measures to protect your personal information. We will take all reasonable and feasible measures to ensure that irrelevant personal information is not collected.",
    setup220: "5. Policy Updates",
    setup221: "In order to bring you a better product and service experience, we are constantly working to improve our products, services and technologies. When new services and business processes change, we may update our privacy policy to inform you of specific changes. Please pay attention to this page in a timely manner and refer to the latest policy on the page. Once the latest policy is released, it will be binding on you.",
    setup222: "6. Contact Us",
    setup223: "If you have any questions about the privacy statement, please contact: ",
    setup224: "Please read the 51shopy Terms of Service carefully before registering as a user and make sure you fully understand these terms. Please carefully read and choose to accept or not accept the 51shopy Terms of Service, especially the terms of exemption or limitation of liability, applicable law and dispute resolution. Unless you accept this 51shopy Terms of Service, you have no right to register, log in or use 51shopy services. Your registration, login and use will be deemed as your acceptance of the 51shopy Terms of Service and your agreement to be bound by the 51shopy Terms of Service.",
    setup225: "The 51shopy Terms of Service stipulates the rights and obligations of you and 51shopy regarding 51shopy services (hereinafter referred to as 'services'). This 51shopy Terms of Service may be updated by 51shopy at any time. Once the updated 51shopy Terms of Service are released and publicized, they will replace the original terms without further notice. You can check the latest version of the 51shopy Terms of Service on the 51shopy platform. At the same time, it is recommended that you keep abreast of the updated 51shopy Terms of Service to avoid unnecessary misunderstandings and disputes. After the 51shopy Service Terms are modified, if you do not accept the modified terms, please stop using the services provided by 51shopy immediately. Your continued use of the services provided by 51shopy will be deemed as acceptance of the modified 51shopy Service Terms. ",
    setup226: "1. Scope of application of this Service Terms",
    setup227: "The ownership and operation rights of the relevant registered user services belong . The services provided must be implemented in accordance with its published service rules, terms and operating specifications, and it also represents that the relevant users have reached an agreement with 51shopy and accepted all its service terms. ",
    setup228: "2. Information collection and use",
    setup229: "When you use 51shopy's services, we may need to collect and use your personal information including the following two types:",
    setup230: "1. In order to provide you with the basic functions of our services, you must authorize us to collect and use necessary information. If you refuse to provide the corresponding information, you will not be able to register, log in or use our services normally;",
    setup231: "2. In order to provide you with additional functions of our services, you can choose to agree or disagree with the information we collect and use. If you refuse to provide, you will not be able to use the relevant additional functions normally or achieve the functional effects we intend to achieve, and it will not affect your use of our basic functions. ",
    setup232: "We protect your right to know and right to choose during the installation or use process in accordance with the law. During your use of 51shopy services, services involving functions provided on your device require your prior consent. After your confirmation, 51shopy has the right to enable necessary auxiliary functions such as collecting geographic location, reading address book, using camera, and enabling recording services. ",
    setup233: "The information collected and used includes but is not limited to basic information such as user's name and contact information. Users agree that the use of this information is subject to the provisions of Article 3 'User Information Protection'. ",
    setup234: "3. User information protection",
    setup235: "We will not disclose or reveal your personal information to third parties unless:",
    setup236: "1. Sharing necessary to fulfill legal obligations;",
    setup237: "2. Sharing with your consent;",
    setup238: "4. User rights and obligations",
    setup239: "1. You have the right to log in to the 51shopy website to review, correct and supplement your personal information. ",
    setup240: "2. You have the right to contact the online customer service to apply for cancellation of your account. After you actively cancel your account, we will stop providing services to you and delete or anonymize your personal information in accordance with the requirements of relevant laws. ",
    setup241: "3. In some business functions, we may make decisions based solely on non-human automatic decision-making mechanisms including algorithms. If these decisions affect your legal rights and interests, you can contact us through customer service. ",
    setup242: "4. All information you provide to 51shopy should be true, accurate and not misleading. ",
    setup243: "You understand and agree that you have the obligation to maintain the authenticity and validity of the information you provide. ",
    setup244: "5. You may not use your registered account or 51shopy services to create, upload, copy, publish or disseminate content that interferes with the normal operation of 51shopy or infringes on the legitimate rights and interests of other users or third parties. ",
    setup245: "6. You may not copy, plagiarize, sell, resell or use any part of 51shopy services or content used or obtained through 51shopy services for any other commercial purposes. ",
    setup246: "7. You shall be solely responsible for the authenticity, legality, accuracy and validity of any information transmitted through your 51shopy account or 51shopy services. Any legal liability related to any information you transmit shall be borne by you and has nothing to do with 51shopy. You shall compensate 51shopy or any third party for any losses caused thereby, and 51shopy reserves the right to hold relevant users and users accountable. ",
    setup247: "8. You shall be fully responsible for the results of all actions under your account (including but not limited to signing various agreements, publishing information, purchasing goods and services, and disclosing information online). ",
    setup248: "5. Information Storage",
    setup249: "'51shopy' has no upper limit on the amount of information transmitted. We have taken reasonable and feasible security measures that meet industry standards to protect your information and prevent personal information from being accessed, disclosed, used, modified, damaged or lost without authorization. Please also properly protect your personal information and provide it to others only when necessary. Do not trust other trading tools to conduct transactions to avoid information theft or even online fraud. ",
    setup250: "6. Disclaimer",
    setup251: "1. The product information provided by 51shopy will restore the real situation as much as possible, but due to the influence of various factors such as the surrounding environment, shooting angle, equipment differences, etc. during the product shooting process, we cannot guarantee that the product is exactly the same as the real thing. ",
    setup252: "2.51shopy purchases designated products based on the platform specified by the user. If the platform you specify is out of stock, price changes, untimely delivery, actual products do not match the product information on the website, products are abnormal or other force majeure factors lead to failure to purchase normally, we will communicate with you in time. Therefore, '51shopy' does not assume any responsibility for the losses caused to you. ",
    setup253: "3. If the products you purchased from 51shopy involve after-sales problems (such as out of stock, damage, defects, etc.), we will handle them for you in a timely manner. ",
    setup254: "4. 51shopy does not assume any responsibility for any losses or consequences caused by your active disclosure of the 51shopy account or by attacks, frauds, etc. by others. You should seek compensation from the infringer through judicial relief or other means. ",
    setup255: "7. Prohibited Behavior",
    setup256: "You may not use 51shopy services to conduct the following activities:",
    setup257: "(1) Violate any laws, regulations, decrees or rules. ",
    setup258: "(2) Transactions involving:",
    setup259: "(a) narcotics, steroids, certain controlled drugs, or other products that may endanger consumer safety;",
    setup260: "(b) drug paraphernalia;",
    setup261: "(c) cigarettes;",
    setup262: "(d) unlicensed marijuana or other psychoactive plants;",
    setup263: "(e) subscription-based nutrition, vitamins, supplements, herbs, and natural health products;",
    setup264: "(f) items that incite, induce, assist, or direct others to engage in illegal activities;",
    setup265: "(g) stolen items, including digital items and virtual items;",
    setup266: "(h) items that incite hatred, violence, racial or other forms of bigotry or exploit criminal activity;",
    setup267: "(i) items that are considered obscene;",
    setup268: "(j) Items that infringe or violate copyright, trademark, publicity or privacy or any other proprietary right under the laws of any jurisdiction;",
    setup269: "(k) certain pornographic items or services;",
    setup270: "(l) ammunition, weapons or certain weapon parts or accessories, or",
    setup271: "(m) certain weapons or knives regulated by applicable law. ",
    setup272: "(3) transactions that:",
    setup273: "(a) disclose personal information of third parties in violation of applicable law;",
    setup274: "(b) support pyramid schemes, Ponzi schemes, matrix schemes, other get-rich-quick schemes, or certain multi-level downline schemes;",
    setup275: "(c) transactions related to the purchase of annuities or lottery contracts, prepaid deposit purchase systems, offshore banking, or financing or refinancing of credit card debt;",
    setup276: "(d) sell certain items before the seller has control or possession of the item;",
    setup277: "(e) payment processors collect payments on behalf of merchants;",
    setup278: "(f) involve the sale of traveler's checks or money orders;",
    setup279: "(g) involve currency exchange or check cashing operations;",
    setup280: "(h) involve certain credit repair or debt settlement services, credit card transactions, or insurance activities, or",
    setup281: "(i) Involving the payment or acceptance of money related to bribery or corruption. ",
    setup282: "(4) Involving the sale of products or services that government agencies have determined may be fraudulent. ",
    setup283: "You shall bear legal responsibility for your use of 51shopy services. You shall bear legal responsibilities including but not limited to compensating the infringed party for losses. After 51shopy first bears legal responsibilities such as administrative penalties or infringement compensation caused by user behavior, you shall pay 51shopy an equal amount of compensation and other losses suffered by 51shopy as a result. ",
    setup284: "8. Compensation Liability",
    setup285: "1. If 51shopy and/or its affiliates suffer losses (including direct economic losses, loss of goodwill, and indirect economic losses such as compensation, settlement, attorney fees, preservation insurance, litigation fees, etc.) due to your behavior, you shall compensate 51shopy and/or its affiliates for all losses. ",
    setup286: "2. If 51shopy and/or its affiliates are subject to claims by a third party (including but not limited to sellers on Taobao, 1688 and other platforms) due to your behavior, 51shopy and/or its affiliates may recover all losses from you after assuming obligations such as monetary compensation to the third party. ",
    setup287: "9. Applicable Law and Jurisdiction",
    setup288: "1. This Service Agreement and any separate agreement we provide you with services shall be governed by and interpreted in accordance with the laws of Hong Kong. ",
    setup289: "2. Any disputes arising from your use of 51shopy services and disputes related to 51shopy services shall be resolved through consultation between 51shopy and you. If the consultation fails, either party may file a lawsuit in a court with jurisdiction over the place where this Agreement is signed. ",
    setup290: "The following is the warehouse outbound (sent to the logistics provider's warehouse)/logistics provider pick-up schedule, for reference only (the actual schedule is subject to the arrangements of each logistics provider):",
    setup291: "Package delivery/pickup time:",
    setup292: "When the parcel status in the 51shopy warehouse is 'Packed', the warehouse and logistics company will arrange delivery/pickup within a fixed time (logistics companies are closed on weekends and holidays, and pickup will be postponed).",
    setup293: "Route",
    setup294: "Dispatch/pickup arrangement (Beijing time)",
    setup295: "GD-EMS",
    setup296: "Pick up from Monday to Sunday",
    setup297: "GD-EUB",
    setup298: "Pick up from Monday to Sunday",
    setup299: "GD-E-EMS",
    setup300: "Pick up from Monday to Sunday",
    setup301: "EUB-T",
    setup302: "Pick up from Monday to Sunday",
    setup303: "DHL Express",
    setup304: "Pick up from Monday to Saturday",
    setup305: "DHL Standard Express",
    setup306: "Pick up from Monday to Saturday",
    setup307: "European DHL Special Line",
    setup308: "Shipping from Monday to Sunday (delivered to the logistics provider's warehouse)",
    setup309: "US Line (Small)",
    setup310: "Shipping from Monday to Sunday (delivered to the logistics provider's warehouse)",
    setup311: "UK Line (Small)",
    setup312: "Shipping from Monday to Sunday (delivered to the logistics provider's warehouse)",
    setup313: "Korea EMS",
    setup314: "Shipping from our warehouse every day",
    setup315: "PDB Postal Parcel",
    setup316: "Sea Parcel",
    setup317: "European Railway",
    setup318: "United Parcel Service Hong Kong Limited",
    setup319: "Aramex Special Line",
    setup320: "SAL",
    setup331: "EMS",
    setup332: "PD-EUB",
    setup333: "UK Line",
    setup334: "NH-EMS",
    setup335: "European Duty-Free Special Line",
    setup336: "US Line",
    setup337: "YTO Express",
    setup338: "SF Express",
    setup339: "51shopy is a platform that provides Chinese product shopping and forwarding services, providing users with product information search, shopping and forwarding services. During this period, 51shopy provides basic product inspection services, communication confirmation with merchants and after-sales services to protect your legal rights and interests and ensure your shopping experience.",
    setup340: "If you find that the purchased goods are counterfeit or inferior, please contact our customer service or send an email to",
    setup341: "1. Receiving and inspection: After the product quality is checked and put into the 51shopy warehouse, or after you receive the package, if you find that the product has quality problems or doubts its authenticity, please contact customer service as soon as possible and provide relevant evidence.",
    setup342: "2. Complaint materials: Provide the order, payment receipt, product description of the purchased goods, and the description of the evidence of counterfeit and inferior goods. ",
    setup343: "3. After receiving your complaint materials, our customer service team will understand the specific situation with you and assist you in communicating with the seller to solve the problem and try our best to fight for your legal rights. ",
    setup344: "Please note that due to the authenticity of the goods, further professional evaluation and legal procedures may be required. If a professional evaluation agency is required for appraisal, the evaluation fee will be borne by you. In order to protect the rights and interests of all parties, we recommend that you choose formal channels and reputable sellers when purchasing to reduce the risk of purchasing counterfeit goods. ",
    setup345: "What is a 14-day return/exchange guarantee? ",
    setup346: "The five-day return and exchange guarantee is a special after-sales service (including the service itself and technical support) provided by third-party platform sellers to consumers. Within 14 days after the goods are signed for (that is, within 14 days after the goods are put into storage), buyers can return or exchange the purchased goods in accordance with these rules and the relevant rules issued by the third-party platform. ",
    setup347: "How to determine whether the product meets the return/exchange guarantee conditions? ",
    setup348: "The product is either 'eligible' for the 14-day free return and exchange service, or 'not eligible' for the 14-day free return and exchange service",
    setup349: "Is it available",
    setup350: "Type",
    setup351: "For example",
    setup352: "Not available",
    setup353: "Determined based on the information provided by the merchant. If we cannot confirm, we will negotiate with the seller about the return/exchange, but the final result is subject to the seller's decision. ",
    setup354: "Customization",
    setup355: "Customized design products",
    setup356: "Explicitly do not support returns and exchanges",
    setup357: "Promotional defective products",
    setup358: "Products whose packaging, labels, and accessories have been removed at the request of the user",
    setup359: "Clothing labels have been torn off",
    setup360: "Newspapers and periodicals",
    setup361: "Subscribed books and periodicals",
    setup362: "Second-hand products",
    setup363: "Products outside mainland China",
    setup364: "Products purchased overseas and in Hong Kong and Macau",
    setup365: "Underwear",
    setup366: "Underwear, socks, leggings",
    setup367: "Adult products",
    setup368: "Other matters stipulated by the seller",
    setup369: "Comply with the seller's rules",
    setup370: "Food",
    setup371: "Biscuits, candies, etc.",
    setup372: "Books (≥15 books)",
    setup373: "No less than 15 books",
    setup374: "Opened items that require 'special standards' for return packaging.",
    setup375: "For sealed products, please refer to the attached table",
    setup376: "Available",
    setup377: "For return/exchange requests submitted within 14 days of receipt, we will handle them according to standard procedures.",
    setup378: "When the product meets all of the following requirements:",
    setup379: "1. The seller provides a return guarantee;",
    setup380: "2. It is in a re-saleable condition required by the seller;",
    setup381: "3. It has not been in storage for more than 14 days. ",
    setup382: "For products with free shipping, you will be responsible for the shipping cost when returning the product. For products without free shipping, you will be responsible for the shipping cost when the seller sends the product to our warehouse and the shipping cost when you return the product to the seller. ",
    setup383: "How to apply for return/exchange service",
    setup384: "You can apply for return/exchange service on the page within 14 days after the order status changes to 'Inventory' (calculated from the next hour after the status changes to 'Inventory', 14 days = 336 hours). Applications may not be accepted after the time limit. ",
    setup385: "Precautions and FAQs",
    setup386: "Notes:",
    setup387: "The total refund/exchange amount is based on the actual product price you paid",
    setup388: "We can only return/exchange for you if the seller agrees",
    setup389: "After applying for return/exchange service, please make sure that there is enough balance in your account to pay for the return shipping and service fees. ",
    setup390: "Please refer to the table below for the return packaging requirements of some products. If the requirements are not met, you will not be able to return/exchange. ",
    setup391: "Special Standards",
    setup392: "Product Categories",
    setup393: "Special Standards",
    setup394: "New Sports Shoes",
    setup395: "Anti-theft buckles (if any) and anti-tamper stickers have not been cut/removed and are fully functional. ",
    setup396: "Detergents/Tampons/Paper/Perfumes",
    setup397: "Personal care products' single-use sealed packaging (if any) must remain sealed. ",
    setup398: "Hair Care/Wigs",
    setup399: "Hair Care products' single-use sealed packaging (if any) must remain sealed. ",
    setup400: "Skin Care/Body Care/Essential Oils",
    setup401: "Product's single-use sealed packaging (if any) must remain sealed",
    setup402: "Cosmetics/Perfumes/Beauty Tools",
    setup403: "Digital Products/Household Appliances (excluding cameras and large appliances)",
    setup404: "1. Internet access license is not damaged (destroyed). ",
    setup405: "2. No water damage. ",
    setup406: "Digital camera/SLR camera/Camera",
    setup407: "The shutter of the SLR camera should not be pressed more than 20 times. ",
    setup408: "Large appliances",
    setup409: "1. LCD TV, air conditioner: Not yet mounted on the wall, simple debugging can be performed. ",
    setup410: "2. Washing machine: Not yet used with water. ",
    setup411: "Model/Anime peripherals/Anime peripherals/Role playing products/Board games",
    setup412: "The tape and plastic seals (if any) on models, figurines, soldier models, BJD and other products cannot be removed. ",
    setup413: "Electronic components",
    setup414: "1. Soldering is prohibited. ",
    setup415: "2. Integrated circuits have never been mounted on any IC base. ",
    setup416: "3. Disposable sealed packages of consumables such as thermal grease/thermal paste, electronic glue/potting glue/sealant/adhesive, conductive glue, conductive ink, etc. must remain sealed. ",
    setup417: "Secondary category 'Game Software' under the primary category 'Electronic Games/Accessories/Games/Game Guides'",
    setup418: "Pet food, health products and medicines under the primary category 'Pets/Pet Food and Supplies'",
    setup419: "Books/Magazines",
    setup420: "1. Disposable sealed packages of goods (if any) must remain sealed",
    setup421: "2. There should be no traces of folding, water stains, stains, ink, or reading on the goods. ",
    setup422: "Secondary category 'Animal Health Products/Veterinary Drugs' under the primary category 'Animal Husbandry/Agricultural Products'",
    setup423: "Disposable sealed packaging (if any) for products such as food (including supplements), cosmetics, medical devices, contraceptives, personal care products, adult products, baby diapers, books and audio-visual products must remain sealed. ",
    setup424: "'Seal' means: the seal or plastic packaging used by the manufacturer on the product packaging. ",
    setup425: "Frequently Asked Questions:",
    setup426: "1. What should I do if there are after-sales problems with orders that are not covered by the 'Return/Exchange Guarantee'? ",
    setup427: "When there are quality problems with the product, 51shopy will verify with the seller based on the actual situation, formulate a final solution and notify the user. If there are no quality problems with the product, according to the rules of the third-party platform, the return and exchange service cannot be provided. 51shopy will try its best to communicate with the seller to protect the rights and interests of users. ",
    setup428: "2. Who is responsible for the shipping cost when using the 'Return/Exchange Guarantee'? ",
    setup429: "Before applying for return and exchange service, the product must be brand new and meet the resale conditions. If the product has no quality problems, the shipping cost shall be borne by the user. If the product has quality problems, the seller shall bear the shipping cost after the user submits the application. ",
    setup430: "3. If the order status is not shipped, is there any charge for requesting return service? ",
    setup431: "Don't worry, there is no charge in this case. You will only be charged if the return and exchange request meets three conditions: First, the product has no quality problems. Second, the product is already in stock in the warehouse. Third, you have used up the number of free returns and exchanges this month. Therefore, when the product has not been shipped, we will not charge you any fees. ",
    setup432: "Email:",
    setup433: "Tel: +85251387262",
    setup434: "Address: Room 341, 3/F, Public Industrial Building, 56 Kai Yuen Road, Kwun Tong, Hong Kong",
    setup435: "Powered By 51shopy - Space Network Technology Co., Ltd.",
    setup436: "Help you deal with",
    setup437: "Best seller yesterday",
    setup438: "Best seller now",
    setup439: "Sold",
    setup440: "Payment failed",
    setup441: "Waiting for payment of postage",
    setup442: "Postage paid, waiting for confirmation from bank",
    setup443: "Postage paid",
    setup444: "Specifications",
    setup445: "Actual payment",
    setup446: "It is recommended that you consider carefully before canceling the order. After the order is canceled, the platform will not be responsible!",
    setup447: "Switch payment",
    setup448: "Pay postage",
    setup449: "Mall order",
    setup450: "More",
    setup451: "Mall",
    setup452: "Purchasing",
    setup453: "Publish",
    setup454: "Sell",
    setup455: "History",
    setup456: "Purchasing",
    setup457: "Amount payable",
    setup458: "Enter the store",
    setup459: "View more",
    setup460: "Collapse",
    setup461: "Enter",
    setup462: "The product has been sold out.",
    setup463: "We recommend the following similar products",
    setup464: "Similar products",
    setup465: "Disclaimer",
    setup467: "Packaging refers to the original packaging of the product. If it is inspected, the logistics packaging will be removed except for the product itself. To avoid damage to the product, the necessary protective packaging materials will be retained. If you request to remove the packaging, we are not responsible.",
    setup468: "Domestic comprehensive freight For the goods of the same seller, the freight deviation will be adjusted by us.",
    setup469: "For each product, we will take photos for you free of charge 3-7 photos. If you have additional requirements for exquisite photo services, we may charge a small service fee. ",
    setup470: "Customized products do not support returns and exchanges. ",
    setup471: "For products approved for return and exchange by the merchant, you can apply for return and exchange within 14 days after the order status changes to 'in stock'. When you request a return or exchange, you need to bear a handling fee of about US$0.75 and domestic shipping costs for each different product return, the total amount is about US$3. ",
    setup472: "Select All",
    setup473: "Postage Routes",
    setup474: "Shipping Fees",
    setup475: "Requires the length, width and height information of the package",
    setup476: "Transit Time",
    setup477: "Days",
    setup478: "Tax-free",
    setup479: "Insurance Available",
    setup480: "Shipping Estimate",
    setup481: "Search Password Registry",
    setup482: "Merchant",
    setup483: "Please pay in",
    setup484: "Payment will be cancelled otherwise",
    setup485: "Total Price",
    setup486: "Final Amount",
    setup487: "Pay Now",
    setup488: "Insufficient Balance, Please Top Up and Pay",
    setup489: "No Suitable Payment Method? You can try to pay with the balance first",
    setup490: "In stock",
    setup491: "Freight quoted",
    setup492: "Freight paid",
    setup493: "Out stock",
    setup494: "Continue to pay",
    setup495: "International logistics order number",
    setup496: "Domestic logistics order number",
    setup497: "Your browser does not support HTML5 video player. ",
    setup498: "Only support uploading PNG and JPEG format images! ",
    setup499: "Complete",
    setup500: "Return",
    setup501: "You do not have permission to go to this page",
    setup502: "Transportation calculation",
    setup503: "Cooperate with many logistics companies to provide the most favorable discounts",
    setup504: "Freight estimate",
    setup505: "Search for products",
    setup506: "View products according to search conditions",
    setup507: "Basic information",
    setup508: "Please enter the English name",
    setup509: "Please enter the Chinese name",
    setup510: "Uploaded videos can only be in MP4, WebM or OGG format!",
    setup511: "The size of the uploaded video cannot exceed 2MB!",
    setup512: "The video length cannot exceed",
    setup513: "seconds",
    setup514: "Unable to obtain the video length, please check whether the video file is damaged",
    setup515: "Data",
    setup516: "",
    setup517: "Please enter sku",
    setup518: "Please enter the quantity",
    setup519: "Please enter the price",
    setup520: "Please enter the English product details",
    setup521: "Please enter the Chinese product details",
    setup522: "Simplified Chinese",
    setup523: "Spanish",
    setup524: "Portuguese",
    setup525: "Dutch",
    setup526: "Polish",
    setup527: "German",
    setup528: "French",
    setup529: "Italian",
    setup530: "Enable multiple specifications",
    setup531: "Price (CNY)",
    setup532: "Add Spec Pics",
    setup533: "Add Spec Val",
    setup534: "① Double-click to modify, drag to adjust the order",
    setup535: "Add specifications",
    setup536: "Batch settings",
    setup537: "Please publish on the PC side",
    setup538: "Name",
    setup539: "Upload product videos",
    setup540: "warehouse entry time",
    setup541: "warehouse exit time",
    setup543: "My Release",
    setup544: "Please authenticate as a merchant before publishing the product",
    setup545: "Please go to the PC end to publish the product",
    setup546: "destination",
    setup547: "United States of America",
    setup548: "Weight (grams)",
    setup549: "Product category",
    setup550: "Please select category",
    setup551: "length",
    setup552: "width",
    setup553: "height",
    setup554: "QUERY",
    setup555: "comprehensive",
    setup556: "Can be insured",
    setup557: "duty-free",
    setup558: "shipping fee",
    setup559: "Need package length, width, and height information",
    setup560: "Transportation time",
    setup561: "days",
    setup562: "Cancel ustd payment successfully!",
    setup563: "dayReminder: Please select your destination country, and the system will search for available routes at that locations",
    setup564: "Package restrictions",
    setup565: "Minimum weight limit:",
    setup566: "Maximum weight limit:",
    setup567: "Volume weight billing rules:",
    setup568: "Size limit:",
    setup569: "Unable to send",
    setup570: "Can send",
    setup571: "Fee Standards:",
    setup572: "unit of weight",
    setup573: "unit price",
    setup574: "Customs Fee",
    setup575: "Fuel cost",
    setup576: "Operation fee",
    setup577: "This bank's credit limit is insufficient, so you cannot select this bank!",
    setup578: "The 51 coin balance is insufficient, please recharge!",
    setup579: "remark",
    setup580: "Please select the product you want to delete!",
    setup581: "Sign in with Google",
    setup582: "The first image is set as the main product by default. Drag to adjust.",
    setup583: "Maximum upload limit reached",
    setup584: "Log in using Telegram",
    setup585: "View logistics",
    setup586: "Logistics information",
    setup587: "Modify logistics order number",
    setup588: "Bind email",
    setup589: "Please bind your email first",
    setup590: "Fill in up to 2 specification types!",
    setup591: "Common templates",
    setup592: "Select model",
    setup593: "Cancel",
    setup594: "Add",
    setup595: "Please select specification value",
    setup596: "Do not add repeatedly",
    setup597: "Set common template successfully!",
    setup598: "SKU cannot be empty",
    setup599: "Price cannot be empty",
    setup600: "Quantity cannot be empty",
    setup601: "Cannot add the same specification value!",
    setup602: "① Double-click to modify",
    setup603: "Please fill in the specification information!",
    setup604: "Please fill in the product details in both simplified Chinese and English!",
    setup605: "Modification successful",
    setup606: "Add specification value successfully!",
    setup607: "Set as common",
    setup608: "Fill in at least one specification value!",
    setup609: "Please enter Simplified Chinese",
    setup610: "Please enter English",
    setup611: "Please enter Spanish",
    setup612: "Please enter Portuguese",
    setup613: "Please enter Dutch",
    setup614: "Please enter Polish",
    setup615: "Please enter German",
    setup616: "Please enter French",
    setup617: "Please enter Italian",
    setup618: "Automatic translation",
    setup619: "Translation",
    setup620: "All others",
    setup621: "SHIPPING INFORMATION",
    setup622: "Our goal is to offer you the best shipping options, no matter where you live. We deliver to hundreds of customers across the world every day, and we strive to provide you with services of the highest level.",
    setup623: "A.The time frame of an order delivery is divided into two parts:",
    setup624: "· Processing time: 3-7 Days",
    setup625: "· Shipping time: 14~30 Days",
    setup626: "B.Shipping methods",
    setup627: "C.Shipping fee",
    setup628: "Intellectual Property Rights",
    setup629: "Land/Sea Transport",
    setup630: "Waiting for receipt",
    setup631: "Affiliate",
    setup632: "Share your affiliate code",
    setup633: "The friend you invited confirms receipt of your affiliate code",
    setup634: "Receive your affiliate commission",
    setup635: "Copy this URL and use it to redirect users to your affiliate ID's homepage",
    setup636: "Copy URL",
    setup637: "My Alliance",
    setup638: "Record",
    setup639: "Get",
    setup640: "Benefits FAQ",
    setup641: "What is the affiliate program?",
    setup642: "51Shopy is a sharing and earning project initiated by all users. Whether you are an individual or a seller, join a 51Shopy promoter, invite new users to register on 51Shopy and successfully purchase, he/she will become your exclusive user, and each of his/her international logistics consumption will bring you cash rebates, and the rebate amount can be as high as one million yuan, with no upper limit.",
    setup643: "How is my bonus calculated?",
    setup644: "Once you become a member, your account will immediately have a rebate rate. The more international logistics freight users you invite to register, the more bonuses you will get, and the higher your rebate rate will be. When the bonus reaches a certain amount, you can apply for withdrawal, or use it to offset any service fees of the 51Shopy platform. The rebate rate is",
    setup645: "How to promote for free?",
    setup646: "Copy your promotional link or promotional link by clicking Share on the product page and send it to your friends. When they visit and register, they will become your only user.",
    setup647: 'Registration time',
    setup648: 'Shipping cost',
    setup649: 'Activation status',
    setup650: 'Bonus record',
    setup651: 'Application time',
    setup652: 'Total reward',
    setup653: 'Invite user',
    setup654: 'Go to wallet',
    setup655: "Credit Card",
    setup656: "Invite friends to enjoy commission",
    setup657: "Affiliate Member",
    setup658: "Purchase Order",
    setup659: "51Shopy agent platform provides you with help in purchasing products online and offline in China. Simply provide the product link and place an order, and our team will provide first-class service from start to finish",
    setup660: "Ship to warehouse",
    setup661: "With us, you can purchase products from various sellers and have them shipped to 51Shopy's warehouse in China",
    setup662: "Quality Inspection",
    setup663: "Once your items arrive at the 51Shopy warehouse, we will conduct a thorough quality inspection covering everything from defects, size to color. You can rest assured that 51Shopy provides a reliable after-sales service guarantee.",
    setup664: "Global Delivery",
    setup665: "At the 51Shopy warehouse, you can freely choose and combine items and pack them and ship them to your home using the reliable logistics service provided by 51Shopy.",
    setup666: "One-stop service, worry-free throughout the process",
    setup667: "Once the users you invite register, they will receive USD:",
   
    setup668:"Free shipping",
setup669:"Not free shipping",
setup670:"International shipping is not included",
setup671:"Logistics company",
setup672:"Select logistics company",
setup673:"Sender's last number",
setup674:"Last four digits",
setup675:"Consignor number",
setup676:"Please enter",
setup677:"Waiting for storage",
setup678:"Does it include international postage",
setup679:"Yes",
setup680:"No",
setup681: "Click the 'Add to Home Screen' button",

}